export default [
  {
    path: 'notification-inbox',
    name: 'notification-inbox',
    component: () => import('@/views/pages/notification/NotificationInbox.vue'),
    meta: {
      pageTitle: 'Notifications',
      breadcrumb: [
        {
          text: 'Notifications',
          active: true,
        },
      ],
      inbox: true,
    },
  },
  {
    path: 'notification-inbox/:id',
    name: 'notification-inbox-view',
    component: () => import('@/views/pages/notification/View.vue'),
    meta: {
      pageTitle: 'Notifications',
      breadcrumb: [
        {
          to: { name: 'notification-inbox' },
          text: 'Notifications',
          active: false,
        },
        {
          text: 'Notification',
          active: true,
        },
      ],
      inbox: true,
    },
  },
]
